import React from 'react';
import { Toaster } from 'react-hot-toast';

const CustomToaster = ({ isDarkTheme }) => {
  // Define responsive position styles
  const getPositionStyle = () => {
    if (window.innerWidth >= 768) {
      return { // Bottom-right for larger screens
        bottom: "1.5rem",
        right: "1.5rem",
      };
    } else {
      return { // Top-center for smaller screens
        top: "1.5rem",
        left: "50%",
        transform: "translateX(-50%)",
      };
    }
  };

  return (
    <Toaster
      position={window.innerWidth >= 768 ? "bottom-right" : "top-center"}
      toastOptions={{
        style: {
          background: isDarkTheme ? "#1a1a1a" : "#ffffff",
          color: isDarkTheme ? "#f59e0b" : "#92400e",
          borderRadius: "12px",
          fontFamily: "Inter, sans-serif",
          boxShadow: isDarkTheme
            ? "0 4px 20px rgba(245, 158, 11, 0.25)"
            : "0 4px 20px rgba(146, 64, 14, 0.15)",
          border: isDarkTheme
            ? "2px solid rgba(245, 158, 11, 0.3)"
            : "2px solid rgba(210, 125, 45, 0.2)",
          fontSize: "0.9375rem",
          lineHeight: "1.375rem",
          padding: "1rem 1.25rem",
          minWidth: "280px",
          backdropFilter: "blur(4px)",
        },
        success: {
          style: {
            background: isDarkTheme ? "rgba(20, 20, 20, 0.95)" : "rgba(255, 255, 255, 0.95)",
            color: isDarkTheme ? "#f59e0b" : "#92400e",
            border: isDarkTheme
              ? "2px solid rgba(245, 158, 11, 0.4)"
              : "2px solid rgba(210, 125, 45, 0.3)",
          },
          iconTheme: {
            primary: isDarkTheme ? "#f59e0b" : "#b45309",
            secondary: isDarkTheme ? "rgba(20, 20, 20, 0.9)" : "rgba(255, 255, 255, 0.9)",
          },
        },
        error: {
          style: {
            background: isDarkTheme ? "rgba(30, 30, 30, 0.95)" : "rgba(255, 255, 255, 0.95)",
            color: isDarkTheme ? "#f59e0b" : "#92400e",
            border: isDarkTheme
              ? "2px solid rgba(245, 158, 11, 0.5)"
              : "2px solid rgba(210, 125, 45, 0.4)",
          },
          iconTheme: {
            primary: isDarkTheme ? "#f59e0b" : "#b45309",
            secondary: isDarkTheme ? "rgba(30, 30, 30, 0.9)" : "rgba(255, 255, 255, 0.9)",
          },
        },
        loading: {
          style: {
            background: isDarkTheme ? "rgba(20, 20, 20, 0.95)" : "rgba(255, 255, 255, 0.95)",
            color: isDarkTheme ? "#f59e0b" : "#b45309",
          },
          iconTheme: {
            primary: isDarkTheme ? "#f59e0b" : "#b45309",
            secondary: isDarkTheme ? "rgba(20, 20, 20, 0.9)" : "rgba(255, 255, 255, 0.9)",
          },
        },
      }}
      containerStyle={{
        ...getPositionStyle(),
        zIndex: 9999,
        position: "fixed",
      }}
    />
  );
};

export default CustomToaster;